import { IApplicationContainerState } from '../../states/containersState';
import * as application from '../../actions/containers/application';
import * as _ from 'lodash';

const initialState: IApplicationContainerState = {
    isBusy: false,
    progress: null
};

export function applicationReducer(state: IApplicationContainerState = initialState,
                                   action: application.Actions): IApplicationContainerState {
    switch (action.type) {
        case application.ActionTypes.ENABLE_BUSY_FLAG:
            return {
                isBusy: true,
                progress: action.payload || -1
            };
        case application.ActionTypes.DISABLE_BUSY_FLAG:
            return {
                isBusy: false,
                progress: action.payload || -1
            };
        default:
            return state;
    }
};

export const getIsBusy = (applicationContainerState: IApplicationContainerState) => applicationContainerState.isBusy;
export const getProgress = (applicationContainerState: IApplicationContainerState) => applicationContainerState.progress;



// WEBPACK FOOTER //
// ./src/app/stateManagement/reducers/containers/application.reducer.ts